import {
  Button,
  Menu,
  MenuDivider,
  MenuItem,
  Popover,
  Radio,
} from '@blueprintjs/core';
import { ace_index } from '@axo/shared/data-access/types';
import { CardRow } from './CardRow';
import { WorkingListCard } from './WorkingListCard';
import classes from './SelectCard.module.css';

const defaultListener = () => false;

interface Props {
  listDetails: ace_index.WorkingList;
  onSelect: () => void;
  isSelected?: boolean;
  editable?: boolean;
  onEdit?: () => void;
  onDelete?: () => void;
  disabled?: boolean;
}

export function SelectCard({
  listDetails,
  onSelect,
  isSelected = false,
  editable = false,
  onEdit = defaultListener,
  onDelete = defaultListener,
  disabled = false,
}: Props) {
  return (
    <WorkingListCard highlighted={!disabled && isSelected}>
      <CardRow className={classes.actions}>
        <Radio
          name="appliedWorkingList"
          checked={isSelected}
          onChange={onSelect}
          label={listDetails.Name}
          className={classes.radio}
          disabled={disabled}
        />

        {editable && (
          <Popover
            disabled={disabled}
            placement="top-start"
            renderTarget={({ isOpen: _, ...targetProps }) => (
              <Button
                minimal
                disabled={disabled}
                intent="none"
                icon="more"
                {...targetProps}
              />
            )}
            content={
              <Menu>
                <MenuItem
                  text="Delete"
                  icon="trash"
                  intent="danger"
                  onClick={onDelete}
                />
                <MenuDivider />
                <MenuItem text="Edit list" icon="edit" onClick={onEdit} />
              </Menu>
            }
          />
        )}
      </CardRow>
    </WorkingListCard>
  );
}
